import React, { useEffect, useMemo, useState } from "react";
import { Chip, TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";

import api from "../../services/api";
import toastError from "../../errors/toastError";
import { i18n } from "../../translate/i18n";

const normalizeSelectedUsers = (value, options) => {
  if (!Array.isArray(value)) {
    return [];
  }

  return value
    .map((item) => {
      if (typeof item === "object") {
        return item;
      }

      return options.find((option) => option.id === item) || null;
    })
    .filter(Boolean);
};

const ContactWalletField = ({
  value,
  onChange,
  disabled,
  label,
  placeholder,
  helperText,
  margin = "dense",
  size,
  limitTags = -1,
}) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let isMounted = true;

    const loadUsers = async () => {
      setLoading(true);
      try {
        const { data } = await api.get("/users/list");
        if (!isMounted) {
          return;
        }

        setUsers((data || []).map((user) => ({ id: user.id, name: user.name })));
      } catch (err) {
        toastError(err);
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    loadUsers();

    return () => {
      isMounted = false;
    };
  }, []);

  const selectedUsers = useMemo(
    () => normalizeSelectedUsers(value, users),
    [users, value]
  );

  return (
    <Autocomplete
      multiple
      disableCloseOnSelect
      limitTags={limitTags}
      loading={loading}
      size={size}
      options={users}
      value={selectedUsers}
      onChange={(event, selectedOptions) =>
        onChange((selectedOptions || []).map((user) => user.id))
      }
      getOptionLabel={(option) => option?.name || ""}
      getOptionSelected={(option, selectedOption) => option?.id === selectedOption?.id}
      renderTags={(selectedOptions, getTagProps) =>
        selectedOptions.map((option, index) => (
          <Chip
            variant="outlined"
            color="primary"
            size="small"
            label={option.name}
            {...getTagProps({ index })}
          />
        ))
      }
      renderInput={(params) => (
        <TextField
          {...params}
          fullWidth
          variant="outlined"
          margin={margin}
          label={
            label === undefined ? i18n.t("contactModal.form.walletUsers") : label
          }
          placeholder={
            placeholder === undefined
              ? i18n.t("contactModal.form.walletUsersPlaceholder")
              : placeholder
          }
          helperText={
            helperText === undefined
              ? i18n.t("contactModal.form.walletUsersHelp")
              : helperText
          }
        />
      )}
      disabled={disabled}
    />
  );
};

export default ContactWalletField;
